module.exports = __webpack_public_path__ + "03bcb5fb6c9be4933eeda8196d2e4b33.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/images/Sumo.jpg
// module id = 524
// module chunks = 0